import { useState } from "react";

import FilterIcon from "@mui/icons-material/FilterAltRounded";
import { IconButton } from "@mui/material";

import { useClientsSearchContext } from "@/common/contexts/clients-search-context/ClientsSearchContext";
import { useTranslation } from "@/translations";

import { ClientsSearchDialog } from "./components/clients-search-dialog/ClientsSearchDialog";

export function ClientsSearch() {
  const { t } = useTranslation();
  const [showClientsSearchDialog, setShowClientsSearchDialog] = useState<boolean>(false);
  const { filters, handleFiltersUpdate } = useClientsSearchContext();

  return (
    <>
      <IconButton onClick={() => setShowClientsSearchDialog(true)} aria-label={t("layout.header.filter")}>
        <FilterIcon />
      </IconButton>
      {showClientsSearchDialog && (
        <ClientsSearchDialog
          initialFilters={filters}
          onClose={() => setShowClientsSearchDialog(false)}
          onSearch={handleFiltersUpdate}
        />
      )}
    </>
  );
}
